'use strict';

let _ = require('lodash');
let bp = require('./util/breakpoints');
let util = require('./util/util');

let cache = {};
let arrowsStyle = {
    angleLeft: '<button type="button" aria-label="Previous arrow" class="slick-control slick-prev slick-arrow"><svg class="svg-inline" width="10" height="18" viewBox="0 0 10 18" xmlns="http://www.w3.org/2000/svg"><path d="M0 9c0 .144.069.307.172.415l8.007 8.405c.103.108.257.18.395.18a.579.579 0 00.395-.18l.86-.902a.637.637 0 00.171-.415.637.637 0 00-.172-.415L3.076 9l6.752-7.088A.637.637 0 0010 1.497a.601.601 0 00-.172-.415L8.97.18A.579.579 0 008.574 0a.579.579 0 00-.395.18L.172 8.585A.637.637 0 000 9z" fill="#333"/></svg></button>',
    angleRight: '<button type="button" aria-label="Next arrow" class="slick-control slick-next slick-arrow"><svg class="svg-inline" width="10" height="18" viewBox="0 0 10 18" xmlns="http://www.w3.org/2000/svg"><path d="M10 9a.637.637 0 01-.172.415L1.821 17.82a.579.579 0 01-.395.18.579.579 0 01-.395-.18l-.86-.902A.637.637 0 010 16.503c0-.144.069-.307.172-.415L6.924 9 .172 1.912A.637.637 0 010 1.497c0-.162.069-.307.172-.415L1.03.18A.579.579 0 011.426 0c.138 0 .292.072.395.18l8.007 8.405c.103.108.172.27.172.415z" fill="#333"/></svg></button>',
    playIcon: '<svg class="svg-inline play-icon" xmlns="http://www.w3.org/2000/svg" width="10.72" height="12.14" viewBox="0 0 11 13"><path fill="#333" d="M10.31 5.42L1.24.11a.82.82 0 00-1.13.3.84.84 0 00-.11.41v10.5a.82.82 0 00.82.82.81.81 0 00.41-.14l9.07-5.15a.82.82 0 00.31-1.12.89.89 0 00-.3-.31z"/></svg>',
    pauseIcon: '<svg class="svg-inline play-icon" xmlns="http://www.w3.org/2000/svg" width="10.71" height="11.79" viewBox="0 0 11 12"><path fill="#333" d="M9.64 0H7.5a1.07 1.07 0 00-1.07 1.07v9.64a1.07 1.07 0 001.07 1.08h2.14a1.07 1.07 0 001.07-1.08V1.07A1.07 1.07 0 009.64 0zM3.21 0H1.07A1.07 1.07 0 000 1.07v9.64a1.07 1.07 0 001.07 1.08h2.14a1.08 1.08 0 001.08-1.08V1.07A1.07 1.07 0 003.21 0z"/></svg>',
    angleLeftThin: '<button type="button" aria-label="Previous arrow" class="slick-control slick-prev slick-arrow"><svg class="svg-inline" width="10" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m8.5 15-7-7 7-7" stroke="#BCB5B5" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/></svg></button>',
    angleRightThin: '<button type="button" aria-label="Next arrow" class="slick-control slick-next slick-arrow"><svg class="svg-inline" width="10" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1.5 15 7-7-7-7" stroke="#333" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/></svg></button>'
};

const defaultConfig = () => {
    return {
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        rows: 0,
        prevArrow: arrowsStyle.angleLeft,
        nextArrow: arrowsStyle.angleRight,
        playIcon: arrowsStyle.playIcon,
        pauseIcon: arrowsStyle.pauseIcon,
        infinite: false,
        dots: false,
        useGroupRole:false,
    };
};

const getCustomConfig = ($container) => {
    if (!$container) {
        return;
    }

    let tilesMobile = typeof $container.attr('data-tiles-mobile') !== 'undefined' ? $container.attr('data-tiles-mobile') : 0;
    let tilesTablet = typeof $container.attr('data-tiles-tablet') !== 'undefined' ? $container.attr('data-tiles-tablet') : 0;
    let tilesDesktop =typeof $container.attr('data-tiles-desktop') !== 'undefined' ? $container.attr('data-tiles-desktop') : 0;

    return {
        tilesMobile: Number(tilesMobile),
        tilesTablet: Number(tilesTablet),
        tilesDesktop: Number(tilesDesktop)
    };
};

const recsConfig = ($container) => {
    const customConfig = getCustomConfig($container);

    return {
        slidesToShow: customConfig.tilesMobile > 0 ? customConfig.tilesMobile : 2,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        dots: true,
        infinite: true,
        cssEase: 'linear',
        speed: 200,
        useTransform: false,
        dotsClass: 'slick-dots bbw-custom-slider-lines',
        responsive: [{
            breakpoint: bp.values.medium - 1,
            settings: {
                slidesToShow: customConfig.tilesTablet > 0 ? customConfig.tilesTablet : 4,
                slidesToScroll: 2,
                arrows: false,
                dots: true,
            }
        },
        {
            breakpoint: bp.values.large - 1,
            settings: {
                slidesToShow: customConfig.tilesDesktop > 0 ? customConfig.tilesDesktop : 4,
                slidesToScroll: 2,
                arrows: true,
                dots: false,
            }
        }]
    };
};

/**
 * Aligns the height of the marketing tile with the height of the slider
 * @returns {void}
 */
function alignMarketingTile() {
    var $sliders = $('.js-slider');

    $sliders.on('init', function (e, slick) {
        setTimeout(() => {
            var $marketingTile = slick.$slider.find('.js-marketing-tile-slide');
            var onlyMT = $marketingTile.closest('.slick-list').find('.slick-slide').length === 1;

            if (!onlyMT) {
                $marketingTile.height(slick.$slider.height());
            }
            $marketingTile.removeClass('d-none');
        }, 1000);
    });

    $(window).on('resize', _.debounce(function () {
        $sliders.each(function (i, slider) {
            if ($(slider).length > 0 && $(slider).hasClass('slick-initialized')) {
                var $marketingTile = slider.slick.$slider.find('.js-marketing-tile-slide');
                var onlyMT = $marketingTile.closest('.slick-list').find('.slick-slide').length === 1;
                $marketingTile.addClass('d-none');

                if (!onlyMT) {
                    $marketingTile.height(slider.slick.$slider.height());
                }

                $marketingTile.removeClass('d-none');
            }
        });
    }));
}

const initRecommendationSlider = () => {
    var settings = defaultConfig();
    var recsSettings = recsConfig(cache.$jsCartSliders);
    cache.$jsCartSliders.slick(_.extend(settings, recsSettings));
};

const initHomepageRecommendationSlider = () => {
    var settings = defaultConfig();
    var recsSettings = recsConfig(cache.$jsHomepageRecommendationSlider);
    cache.$jsHomepageRecommendationSlider.slick(_.extend(settings, recsSettings));
};

const initBannerSlider = () => {
    var settings = defaultConfig();
    cache.$jsBannerSlider.slick(_.extend(settings, {
        arrows: false,
        infinite: true,
        speed: 0,
        useCSS: false,
        autoplay: true,
        autoplaySpeed: 1000
    }));
};

const initTopOffersBanner = () => {
    var settings = defaultConfig();

    cache.$jsTopOffersSlider.slick(_.extend(settings, {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        autoplay: false,
        dots: true,
        dotsClass: 'slick-dots bbw-custom-slider-dots',
        responsive: [{
            breakpoint: bp.values.medium - 1,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true,
                dots: false
            }
        }, {
            breakpoint: bp.values.large - 1,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                dots: false
            }
        }]
    }));
};

const initBannerWithCarouselSlider = () => {
    var settings = defaultConfig();
    const customConfig = getCustomConfig(cache.$bannerWithCarouselSlider);

    cache.$bannerWithCarouselSlider.slick(_.extend(settings, {
        slidesToShow: customConfig.tilesMobile > 0 ? customConfig.tilesMobile : 2,
        slidesToScroll: customConfig.tilesMobile > 0 ? customConfig.tilesMobile : 2,
        arrows: true,
        autoplay: false,
        infinite: true,
        responsive: [{
            breakpoint: bp.values.medium - 1,
            settings: {
                slidesToShow: customConfig.tilesTablet > 0 ? customConfig.tilesTablet : 2,
                slidesToScroll: customConfig.tilesTablet > 0 ? customConfig.tilesTablet : 2
            }
        }, {
            breakpoint: bp.values.extraLarge - 1,
            settings: {
                slidesToShow: customConfig.tilesDesktop > 0 ? customConfig.tilesDesktop : 3,
                slidesToScroll: customConfig.tilesDesktop > 0 ? customConfig.tilesDesktop : 3,
                arrows: true
            }
        }]
    }));
};

const initNoResultSliders = () => {
    var settings = defaultConfig();
    var recsSettings = recsConfig(cache.$jsNoResultSliders);

    cache.$jsNoResultSliders.slick(_.extend(settings, recsSettings));
};

const initEinsteinSliderPdp = () => {
    var settings = defaultConfig();

    $(document).on('einstein.slider', function () {
        var recsSettings = recsConfig($('.js-einstein-pdp-recommendation-slider'));
        showHalfHandle();
        alignMarketingTile();
        $('.js-einstein-pdp-recommendation-slider').not('.slick-initialized').slick(_.extend(settings, recsSettings));
        $('body').trigger('ratingsAndReviews:init');
        $(window).trigger('alignTiles');
        util.scrollToHash();
    });
};

const initEinsteinSliderCart = () => {
    var settings = defaultConfig();

    $(document).on('einstein.slider.cart', function () {
        var recsSettingsCart = recsConfig($('.js-einstein-cart-recommendation-slider'));
        var recsSettingsHP = recsConfig($('.js-einstein-homepage-recommendation-slider'));
        showHalfHandle();
        alignMarketingTile();
        $('.js-einstein-cart-recommendation-slider').not('.slick-initialized').slick(_.extend(settings, recsSettingsCart));
        $('.js-einstein-homepage-recommendation-slider').not('.slick-initialized').slick(_.extend(settings, recsSettingsHP));
        $('body').trigger('ratingsAndReviews:init');
        $(window).trigger('alignTiles');
    });
};

const initCatTilesSlider = () => {
    var settings = defaultConfig();
    cache.$jsCatTilesSlider.slick(_.extend(settings, {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        centerMode: true,
        centerPadding: '15%',
        infinite: false,
        responsive: [{
            breakpoint: bp.values.small - 1,
            settings: 'unslick'
        }]
    }));
};

const sliderEvents = () => {
    $('.bbw-slider').on('afterChange', function () {
        var $this = $(this);

        if ($this.find('[data-promoview-name]').length > 0) {
            $(document).trigger('sendVisiblePromoViewFromViewport');
        }
    });
};

const showHalfHandle = () => {
    $('.show-half').on('init', function (e, slick) {
        var $this = $(this);

        $this.removeClass('show-half-one-tile');

        if (slick.originalSettings.slidesToShow == 1) {
            $this.addClass('show-half-one-tile');
        }
        if (slick.originalSettings.slidesToShow == slick.slideCount) {
            $this.removeClass('show-half');
        }
    });
};

const initPDSliders = () => {
    var settings = defaultConfig();
    var recsSettings = recsConfig(cache.$jsPDSlider);
    var psSlickSettings = _.extend(settings, recsSettings);

    cache.$jsPDSlider.not('.slick-initialized').slick(_.extend(psSlickSettings, {
        prevArrow: arrowsStyle.angleLeftThin,
        nextArrow: arrowsStyle.angleRightThin
    }));
};

const initFilteredHeadersSlider = () => {
    var settings = defaultConfig();
    cache.$jsFilteredHeadersSlider.slick(_.extend(settings, {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        dots: true,
        infinite: true,
        dotsClass: 'slick-dots bbw-custom-slider-dots',
        responsive: [{
            breakpoint: bp.values.medium - 1,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
            }
        }]
    }));
};

const initFilteredHeadersSliderCTA = () => {
    var settings = defaultConfig();
    cache.$jsFilteredHeadersSliderCTA.slick(_.extend(settings, {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        dots: true,
        infinite: true,
        dotsClass: 'slick-dots bbw-custom-slider-dots',
        responsive: [{
            breakpoint: bp.values.small - 1,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true
            }
        }, {
            breakpoint: bp.values.medium - 1,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                dots: false
            }
        }, {
            breakpoint: bp.values.large - 1,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false
            }
        }, {
            breakpoint: bp.values.extraLarge - 1,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: false
            }
        }]
    }));
};

const initPromoBannerSlider = () => {
    var settings = defaultConfig();
    cache.$jsPromoBannerSlider.slick(_.extend(settings, {
        infinite: true,
        slidesToShow: 1,
        arrows: true,
        autoplay: true
    }));
};

const initClpSlider = () => {
    var settings = defaultConfig();
    var recsSettings = recsConfig(cache.$jsClpSlider);
    cache.$jsClpSlider.slick(_.extend(settings, recsSettings));
};

const initEinsteinSliderClp = () => {
    var settings = defaultConfig();

    $(document).on('einstein.slider.clp', function () {
        var recsSettings = recsConfig($('.js-einstein-clp-recommendation-slider'));
        showHalfHandle();
        alignMarketingTile();
        $('.js-einstein-clp-recommendation-slider').not('.slick-initialized').slick(_.extend(settings, recsSettings));
        $('body').trigger('ratingsAndReviews:init');
        $(window).trigger('alignTiles');
    });
};

const initPlpSlider = () => {
    var settings = defaultConfig();
    var recsSettings = recsConfig(cache.$jsPlpSlider);
    cache.$jsPlpSlider.slick(_.extend(settings, recsSettings));
};

const initEinsteinSliderPlp = () => {
    var settings = defaultConfig();

    $(document).on('einstein.slider.plp', function () {
        var recsSettings = recsConfig($('.js-einstein-plp-recommendation-slider'));
        showHalfHandle();
        alignMarketingTile();
        $('.js-einstein-plp-recommendation-slider').not('.slick-initialized').slick(_.extend(settings, recsSettings));
        $('body').trigger('ratingsAndReviews:init');
        $(window).trigger('alignTiles');
    });
};

const initMinicartSlider = () => {
    var settings = defaultConfig();

    $(document).on('minicart.slider', function () {
        const customConfig = getCustomConfig($('.js-minicart-recommendation-slider'));
        showHalfHandle();
        alignMarketingTile();
        $('.js-minicart-recommendation-slider').not('.slick-initialized').slick(_.extend(settings, {
            slidesToShow: customConfig.tilesDesktop > 0 ? customConfig.tilesDesktop : 2,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            dots: false,
            infinite: true,
        }));
        $('body').trigger('ratingsAndReviews:init');
        $(window).trigger('alignTiles');
    });
};

const initJatcSlider = ($slider) => {
    var settings = defaultConfig();
    const customConfig = getCustomConfig(cache.$jsJatcSlider);

    if ($slider) {
        cache.$jsJatcSlider = $slider;
    }

    showHalfHandle();

    cache.$jsJatcSlider.slick(_.extend(settings, {
        slidesToShow: customConfig.tilesDesktop > 0 ? customConfig.tilesDesktop : 2,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        dots: false,
        infinite: true,
    }));
    $('body').trigger('ratingsAndReviews:init');
};

const initJatcEinsteinSlider = () => {
    var settings = defaultConfig();

    $(document).on('jatc.slider', function () {
        const customConfig = getCustomConfig($('.js-einstein-jatc-recommendation-slider'));
        showHalfHandle();
        alignMarketingTile();
        $('.js-einstein-jatc-recommendation-slider').not('.slick-initialized').slick(_.extend(settings, {
            slidesToShow: customConfig.tilesDesktop > 0 ? customConfig.tilesDesktop : 2,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            dots: false,
            infinite: true,
        }));
        $('body').trigger('ratingsAndReviews:init');
        $(window).trigger('alignTiles');
    });
};

const initScSlider = () => {
    var settings = defaultConfig();

    $(document).on('sc.rec.slider', function () {
        $('.js-sc-rec-carousel').not('.slick-initialized').slick(_.extend(settings, {
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            dots: false,
            infinite: true,
            dotsClass: 'slick-dots bbw-custom-slider-dots'
        }));
    });
};

const initTabsRecsSlider = ($slider) => {
    var settings = defaultConfig();
    var recsSettings = recsConfig(cache.$jsTabsRecs);
    var $tabsRecsSlider = cache.$jsTabsRecs;

    if ($slider) {
        $tabsRecsSlider = $slider;
    }

    $tabsRecsSlider.on('init', function (e, slick) {
        setTimeout(() => {
            var $marketingTile = slick.$slider.find('.js-marketing-tile');
            $marketingTile.height(slick.$slider.height());
            $marketingTile.removeClass('d-none');
        }, 100);
    });

    $tabsRecsSlider.slick(_.extend(settings, recsSettings));

    $(window).on('resize', _.debounce(function () {
        if ($tabsRecsSlider.length > 0 && $tabsRecsSlider.hasClass('slick-initialized')) {
            var $marketingTile = $tabsRecsSlider[0].slick.$slider.find('.js-marketing-tile');
            $marketingTile.addClass('d-none');
            $marketingTile.height($tabsRecsSlider[0].slick.$slider.height());
            $marketingTile.removeClass('d-none');
        }
    }));
};

const initTabsCarousel = () => {
    var settings = defaultConfig();

    var initializeSlickBasedOnContent = () => {
        cache.$jsTabsCarousel.each(function (index, carousel) {
            var $carousel = $(carousel);
            var containerWidth = $carousel.width();
            var $tabLinks = $carousel.find('.js-tab-link');
            var tabsWidth = 0;

            $tabLinks.map((i, el) => tabsWidth += $(el).outerWidth());

            if (!$carousel.hasClass('slick-initialized') && containerWidth < tabsWidth) {
                $carousel.slick(_.extend(settings, {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    autoplay: false,
                    dots: false,
                    infinite: false,
                    variableWidth: true
                }));
            } else {
                if ($carousel.hasClass('slick-initialized') && containerWidth > tabsWidth) {
                    $carousel.slick('unslick');
                }
            }
        });
    };

    initializeSlickBasedOnContent();

    $(window).resize(_.debounce(function () {
        initializeSlickBasedOnContent();
    }));
};

module.exports = {
    initCache: function () {
        cache.$jsCartSliders = $('.js-cart-recommendation-slider');
        cache.$jsHomepageRecommendationSlider = $('.js-homepage-recommendation-slider');
        cache.$jsBannerSlider = $('.js-banner-slider');
        cache.$jsTopOffersSlider = $('.js-top-offers-slider');
        cache.$bannerWithCarouselSlider = $('.js-banner-with-carousel-slider');
        cache.$jsNoResultSliders = $('.js-no-result-recommendation-slider');
        cache.$jsCatTilesSlider = $('.js-cat-tiles-slider');
        cache.$jsPDSlider = $('.js-pd-slider');
        cache.$jsFilteredHeadersSlider = $('.js-filtered-headers-slider');
        cache.$jsFilteredHeadersSliderCTA = $('.js-filtered-headers-slider-cta');
        cache.$jsPromoBannerSlider = $('.js-promo-banner-slider');
        cache.$jsClpSlider = $('.js-clp-recommendation-slider');
        cache.$jsPlpSlider = $('.js-plp-recommendation-slider');
        cache.$jsJatcSlider = $('.js-jatc-recommendation-slider');
        cache.$jsTabsRecs = $('.js-tabs-recommendation-slider');
        cache.$jsTabsCarousel = $('.js-tabs-carousel');
    },
    customEvents: function () {
        $(document).on('init:initTabsRecsSlider', function (e, data) {
            if (data && data.$slider) {
                initTabsRecsSlider(data.$slider);
                $('body').trigger('ratingsAndReviews:init');
                $(window).trigger('alignTiles', {container: data.$slider, resetHeight: true});
            }
        });

        $(document).on('init:initJatcSlider', function (e, slider) {
            initJatcSlider($(slider));
        });
    },
    alignMarketingTile: function () {
        alignMarketingTile();
    },
    showHalfHandle,
    initRecommendationSlider,
    initHomepageRecommendationSlider,
    initBannerSlider,
    initTopOffersBanner,
    initBannerWithCarouselSlider,
    initNoResultSliders,
    initEinsteinSliderPdp,
    initEinsteinSliderCart,
    initEinsteinSliderClp,
    initMinicartSlider,
    initEinsteinSliderPlp,
    initJatcEinsteinSlider,
    initPDSliders,
    initFilteredHeadersSlider,
    initFilteredHeadersSliderCTA,
    initJatcSlider,
    initClpSlider,
    initPlpSlider,
    initScSlider,
    initPromoBannerSlider,
    initTabsRecsSlider,
    initTabsCarousel,
    initCatTilesSlider: function () {
        initCatTilesSlider();

        $(document).on('viewportchange', function () {
            if (window.jRes.isXSmall) {
                initCatTilesSlider();
            }
        });
    },
    sliderEvents
};
